// Contracts — kids cabinet RESCHEDULE (task #37). Move an existing meeting to
// another day / time / office. Callable by staff (reception/admin/manager, admin
// scoped to its own office) OR the parent who owns the meeting. Office is limited
// to the two Atlanta offices (KidsOfficeIdSchema) per Tim's spec ("дату время и
// офис из 2 этих атлантовских"). The worker re-allocates the meeting's children
// into slots of the new day/time (allocateChildren) exactly like a fresh booking.
import { z } from 'zod';
import { KidsOfficeIdSchema } from '../kids';

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const TIME_RE = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

// POST /api/kids/meeting/:id/reschedule — body. office ∈ {atl_perimeter,duluth_hq}.
export const KidsMeetingRescheduleReqSchema = z.object({
  office: KidsOfficeIdSchema,
  date: z.string().regex(DATE_RE),
  time: z.string().regex(TIME_RE),
});
export type KidsMeetingRescheduleReq = z.infer<typeof KidsMeetingRescheduleReqSchema>;

// Success → the updated meeting + the re-allocated child slot assignments. On a
// full window the worker returns 409 { error:'slot_unavailable' } (same code as
// booking); an invalid office → 400 (schema) — the enum rejects non-Atlanta ids.
export const KidsMeetingRescheduleResSchema = z.object({
  ok: z.literal(true),
  meeting: z.object({
    id: z.string(),
    office: z.string(),
    date: z.string(),
    time: z.string(),
    status: z.string(),
  }),
  assignments: z.array(z.object({ childId: z.string(), time: z.string() })),
});
export type KidsMeetingRescheduleRes = z.infer<typeof KidsMeetingRescheduleResSchema>;
